import { type ReactNode } from "react";

import { useSelector } from "react-redux";

import type { BoxProps } from "@chakra-ui/react";
import { Box, Center, Spinner } from "@chakra-ui/react";

import { selectIsTrial } from "@state/mondaySlice";

type TrialAwareLayoutProps = {
  children: ReactNode;
} & BoxProps;

const TrialAwareLayout = ({ children, ...rest }: TrialAwareLayoutProps) => {
  const isTrial = useSelector(selectIsTrial);

  return (
    <Box
      h={{
        base: isTrial ? "calc(100vh - 50px)" : "100vh",
        sm: isTrial ? "calc(100vh - 32px)" : "100vh",
      }}
      px="20px"
      py="8px"
      position="relative"
      overflowX="hidden"
      {...rest}
    >
      {children}
    </Box>
  );
};

export const TrialAwareLayoutSpinner = () => {
  return (
    <TrialAwareLayout>
      <Center h="full">
        <Spinner size="xl" />
      </Center>
    </TrialAwareLayout>
  );
};

export default TrialAwareLayout;
